import {useNavigation, useRoute} from '@react-navigation/native';
import React, {useState} from 'react';
import {Alert} from 'react-native';

import {Header as NavBar} from '../../../components/Interface/Headers/Header';
import {Loading} from '../../../components/Interface/Loadings/Loading';

import {api} from '../../../services/api';

import {
  Container,
  Content,
  Header,
  CardInfo,
  Brand,
  CardBrand,
  Number,
  BrandImage,
  FeaturesList,
  FeatureItem,
  Label,
  Text,
  DeleteCardButton,
  DeleteCardButtonIcon,
  DeleteCardButtonText,
} from './styles';
import {useCards} from '../../../context/cards';
import { SafeAreaView } from 'react-native-safe-area-context';

interface Params {
  id: string;
  brand: string;
  image_url: string;
  number: string;
  expiry: string;
  voucher: boolean | null;
}

export function CardWalletInfo() {
  const navigation = useNavigation();
  const route = useRoute();
  const {fetchUserCreditCardList} = useCards();

  const {id, brand, image_url, number, expiry, voucher} =
    route.params as Params;

  const [isLoading, setIsLoading] = useState(false);

  let brandFormatted;

  switch (brand) {
    case 'Master':
      brandFormatted = 'Mastercard';
      break;
    case 'Visa':
      brandFormatted = 'Visa';
      break;
    case 'Amex':
      brandFormatted = 'American Express';
      break;
    case 'Elo':
      brandFormatted = 'Elo';
      break;
    case 'Hiper':
      brandFormatted = 'Hipercard';
      break;
    case 'vr':
      brandFormatted = 'VR';
      break;
    case 'pluxee':
      brandFormatted = 'Pluxee';
      break;
    default:
      brandFormatted = 'Cartão de crédito';
  }

  async function deleteCard() {
    setIsLoading(true);
    await api
      .delete('/cred_card', {
        params: {
          creditcard_id: id,
        },
      })
      .then(() => {
        fetchUserCreditCardList({});
        navigation.goBack();
      })
      .catch(() => {
        Alert.alert('Não foi possível excluir o cartão.');
      })
      .then(() => {
        setIsLoading(false);
      });
  }

  async function deleteCardAlert() {
    Alert.alert('Deseja excluir essa forma de pagamento?', '', [
      {
        text: 'Excluir',
        onPress: deleteCard,
        style: 'destructive',
      },
      {
        text: 'Cancelar',
        style: 'cancel',
      },
    ]);
  }

  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
    <Container>
      {isLoading && <Loading />}
      <NavBar
        icon="chevron-left"
        title="Cartão"

      />

      <Header>
        <CardInfo>
          <Brand>{brandFormatted}</Brand>
          <Number>•••• {number}</Number>
        </CardInfo>
        <CardBrand>
          <BrandImage
            source={{
              uri: image_url,
            }}
          />
        </CardBrand>
      </Header>

      <Content>
        <FeaturesList>
          <FeatureItem>
            <Label>Data de vencimento</Label>
            <Text>{expiry}</Text>
          </FeatureItem>
          <FeatureItem>
            <Label>Tipo de cartão</Label>
            <Text>{voucher ? 'Vale' : 'Cartão de crédito'}</Text>
          </FeatureItem>
        </FeaturesList>

        <DeleteCardButton onPress={deleteCardAlert} activeOpacity={0.7}>
          <DeleteCardButtonIcon name="trash" />
          <DeleteCardButtonText>
            Remover forma de pagamento
          </DeleteCardButtonText>
        </DeleteCardButton>
      </Content>
    </Container>
    </SafeAreaView>
  );
}
